module.exports = __webpack_public_path__ + "img/iconFacebook.724a7823.png";